module.exports = __webpack_public_path__ + "static/media/m-quebonBakery.34bbadc7.png";